import React from 'react';

const SearchResultsCountCard = props => {
  return (
    <a href={props.resultsLink} className="search-results-count-card">
      <p
        className="results-text"
        dangerouslySetInnerHTML={{ __html: props.resultsText }}
      />
      <div className="results-link-text--wrapper">
        <p className="results-link-text" id="results-link-text">{props.resultsLinkText}</p>
        <svg className="right-arrow" width="22px" height="22px" viewBox="0 0 22 22" version="1.1">
          <title>B2E39ABC-E32F-43A9-8AAA-8AB1743A1FEE</title>
          <g id="Style-Guide/Pattern-Library" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Style-Guide---Logo-&amp;-Iconography" transform="translate(-302.000000, -1876.000000)">
              <g id="icon_arrow_right" transform="translate(302.000000, 1876.000000)">
                <rect id="Rectangle" x="0" y="0" width="22" height="22"></rect>
                <path d="M13.0991667,5.23416667 L13.0991667,5.23416667 C12.7416667,5.59166667 12.7416667,6.16916667 13.0991667,6.52666667 L16.6558333,10.0833333 L2.75,10.0833333 C2.24583333,10.0833333 1.83333333,10.4958333 1.83333333,11 L1.83333333,11 C1.83333333,11.5041667 2.24583333,11.9166667 2.75,11.9166667 L16.665,11.9166667 L13.1083333,15.4733333 C12.7508333,15.8308333 12.7508333,16.4083333 13.1083333,16.7658333 L13.1083333,16.7658333 C13.4658333,17.1233333 14.0433333,17.1233333 14.4008333,16.7658333 L19.525,11.6416667 C19.8825,11.2841667 19.8825,10.7066667 19.525,10.3491667 L14.3916667,5.23416667 C14.0433333,4.87666667 13.4566667,4.87666667 13.0991667,5.23416667 Z" id="Path" fill="#004751" fillRule="nonzero"></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </a>
  );
};

export default SearchResultsCountCard;
